import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import PageBodyWrapper from "../../components/PageBodyWrapper";
import useApi from "../../api";

import { handleRetriveError } from "../../utils";



function TranslationMain() {
  const [languages, setLanguages] = useState<any | null>(null);
  const api = useApi();
  const navigate = useNavigate();

  const fetchUsers = () => {
    api.getLanguageList().then((response: any) => {
        setLanguages(response);
      }, handleRetriveError);
  };

  useEffect(() => {
    fetchUsers();
  }, []);


  return (
    <PageBodyWrapper>
      <div className="px-1">
        <table className="max-w-full min-w-0 w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
            <tr>
                <th>Name</th>
                <th>Code (ISO Format)</th>
            </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
            {languages && languages.map((language: any) => (
                <tr onClick={() => navigate(`/dashboard/translations/collections/${language.value}`)} key={language.value} className="hover:bg-gray-100 cursor-pointer">
                    <td className="px-4 py-2 text-gray-800">
                        {language.label}
                    </td>
                    <td className="px-4 py-2 text-gray-800">
                        {language.value}
                    </td>
                </tr>
            ))}
            </tbody>
        </table>
      </div>



     

    </PageBodyWrapper>
  );
}

export default TranslationMain;
